/**
 * Veľkosť rozhrania - Nastavenia → Môj účet → Veľkosť textu.
 *
 * Mierka celej stránky (CSS `zoom` na `<html>`), nie len veľkosť písma:
 * veľa prvkov (kalendár, tabuľky) má rozmery v pixeloch a pri väčšom písme
 * by sa text do nich nezmestil. Je to vec človeka a zariadenia (zrak,
 * veľkosť monitora), preto sa pamätá v prehliadači, nie pri škole.
 */
export const UI_SCALES = [0.875, 1, 1.125, 1.25, 1.375] as const

const KEY = 'l2s:ui-scale'

export function getUiScale(): number {
  try {
    const value = Number.parseFloat(localStorage.getItem(KEY) ?? '')
    return (UI_SCALES as readonly number[]).includes(value) ? value : 1
  } catch {
    return 1
  }
}

export function applyUiScale(scale: number) {
  document.documentElement.style.zoom = scale === 1 ? '' : String(scale)
}

export function setUiScale(scale: number) {
  try {
    localStorage.setItem(KEY, String(scale))
  } catch {
    /* súkromné okno - platí aspoň do obnovenia stránky */
  }
  applyUiScale(scale)
}

/**
 * Súradnice z obrazovky (`getBoundingClientRect`, `clientX`) sú už
 * zväčšené; zapísané späť do `style.top/left` by ich prehliadač zväčšil
 * druhýkrát a vyskakovacie okno by bolo vedľa. Toto ich vráti do mierky
 * stránky.
 */
export function unzoom(value: number): number {
  const zoom = Number.parseFloat(getComputedStyle(document.documentElement).zoom || '1') || 1
  return value / zoom
}
